import { useLazyQuery } from "@apollo/client/react"; import React, { useEffect, useMemo, useState } from 'react';
import 'moment/locale/es';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import { PopoverModal } from '../../../components/popoverModal/PopoverModal';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import './imprimirMinutaGrilla.scss';
import moment from 'moment';
import { ImprimirMinutaGrillaHeader } from './ImprimirMinutaGrillaHeader';
import { ImprimirMinutaGrillaFilters } from './ImprimirMinutaGrillaFilters';
import { usePersistFilters } from '../../../hooks/usePersistFilters';
import { GET_IMPRIMIR_MINUTA_DOCUMENTO } from '../../../data/graphQL/queries/ImprimirMinuta/getImprimirMinutaDocumento';
import fileDownload from 'js-file-download';
import { formatCurrency } from "../../../utils/mathUtils";

import toast from 'react-hot-toast';
import { CircularProgress } from '@mui/material';

export const ImprimirMinutaGrilla = ({ setChildrenAction }) => {

  const navigate = useNavigate();

  const [allowedWrite, setAllowedWrite] = useState(false);
  const [delegaciones, setDelegaciones] = useState([]);
  const [imprimirMinutasGrilla, setImprimirMinutasGrilla] = useState([]);
  const [imprimirMinutasGrillaLoading, setImprimirMinutasGrillaLoading] = useState(false);
  const [printLoading, setPrintLoading] = useState(false);
  const [minutasSeleccionadas, setMinutasSeleccionadas] = useState([]);
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const [numeroFacturaPrint, setNumeroFacturaPrint] = useState('');
  const [refetchGrilla, setRefetchGrilla] = useState(true);

  const mesActualPrimerDia = moment().format("YYYY").toString() + '-' + moment().format("MM").toString() + '-01';
  const initFechaDesde = moment(mesActualPrimerDia).format("YYYY-MM-DD");
  const initFechaHasta = moment(initFechaDesde).add(1, 'months').add(-1, 'days').format("YYYY-MM-DD");

  const { filters, handleChangeFilters } = usePersistFilters({
    fechaDesde: moment(mesActualPrimerDia).format("YYYY-MM-DD"),
    fechaHasta: initFechaHasta,
    idDelegacion: 0
  }, "imprimirMinutaGrillaFilters");

  const location = useLocation();
  const rutasStorage = localStorage.getItem('navigationRoutes');

  useEffect(() => {
    if (rutasStorage) {
      const rutas = JSON.parse(rutasStorage);
      const rutaQueSirve = location.pathname;
      setAllowedWrite(rutas?.find((ruta) => ruta.aplicaciones.find((app) => app.url == rutaQueSirve)
      )?.aplicaciones?.find((app) => app.url == rutaQueSirve).escritura);
    }
  }, [rutasStorage]);

  useEffect(() => {
    setChildrenAction(() =>
      <ImprimirMinutaGrillaHeader
        allowedWrite={allowedWrite}
        minutasSeleccionadas={minutasSeleccionadas}
        setPrintLoading={setPrintLoading} />

    );
  }, [
    setChildrenAction,
    minutasSeleccionadas,
    allowedWrite]
  );

  const handleView = (row) => {
    navigate(location.pathname + '/detalle', {
      state: {
        allowedWrite: allowedWrite,
        dataRegistro: row,
        delegacion: delegaciones.filter((d) => d.id == filters?.idDelegacion)[0]?.name
      }
    });
  };

  const [getPrintDocumento, { data: docData, loading: printDocumentoLoading }] = useLazyQuery(GET_IMPRIMIR_MINUTA_DOCUMENTO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!docData) return;
    if (docData.imprimirMinutaDocumento.success) {
      const arr = new Uint8Array(docData.imprimirMinutaDocumento.valorEsperado);
      const documento = new Blob([arr], { type: 'application/pdf' });
      const fileName = 'NumFact-' + numeroFacturaPrint + '.pdf';
      fileDownload(documento, fileName);
    } else {
      toast.error("No fue posible generar el documento.");
    }
    setPrintLoading(false);
  }, [docData]);


  // imprimir solo 1 minuta desde grilla
  const handlePrint = (row) => {
    setNumeroFacturaPrint(row.numeroFactura);
    getPrintDocumento({ variables: { minutas: [row.idMinuta] } });
  };

  const disabledCheckbox = (row) => {
    return !allowedWrite;
  };

  const handleSelectionModelChange = (ids) => {
    setRowSelectionModel(ids);
    if (ids.length > 0) {
      setMinutasSeleccionadas(imprimirMinutasGrilla.filter((row, index) => {
        return ids.includes(index + 1);
      }));
    } else {
      setMinutasSeleccionadas([]);
    }
  };

  const initialColumns = [
    {
      headerName: '',
      field: 'action',
      cellClassName: 'grid-actions-column',
      minWidth: 20,
      maxWidth: 20,
      width: 20,
      sortable: false,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <>
            <PopoverModal>
              <div className='popover-modal-content'>
                {
                  allowedWrite && !printDocumentoLoading &&
                  <div
                    onClick={() => handlePrint(row)} aria-hidden='true'
                    className='item-option clickable-option'>

                    <PictureAsPdfIcon className='edit-icon' />
                    <span className='toggle-action'>Imprimir</span>
                  </div>
                }
                {
                  allowedWrite && printDocumentoLoading &&
                  <div style={{ paddingLeft: '8px', color: 'gray' }}>
                    <CircularProgress size="22px" color="inherit" />
                  </div>
                }
                <div onClick={() => handleView(row)} aria-hidden='true'
                  className='item-option clickable-option'>

                  <VisibilityIcon className='edit-icon' />
                  <span className='toggle-action'>Ver</span>
                </div>
              </div>
            </PopoverModal>
          </>);
      }
    },
    {
      field: 'idMinuta',
      headerName: 'Minuta',
      flex: 0.15
    },
    {
      field: 'delegacion',
      headerName: 'Delegación',
      flex: 0.26
    },
    {
      field: 'paciente',
      headerName: 'Paciente',
      flex: 0.4
    },
    {
      field: 'cliente',
      headerName: 'Cliente',
      flex: 0.18
    },
    {
      field: 'nombreCliente',
      headerName: 'Nombre Cliente',
      flex: 0.38
    },
    {
      field: 'modulo',
      headerName: 'Prog.',
      flex: 0.14
    },
    {
      field: 'cantConexiones',
      headerName: 'Cnxs',
      description: 'Conexiones',
      flex: 0.11
    },
    {
      field: 'estado',
      headerName: 'Estado',
      flex: 0.17
    },
    {
      field: 'numeroFactura',
      headerName: 'Factura',
      flex: 0.25
    },
    {
      field: 'total',
      headerName: '$ Total',
      flex: 0.21,
      valueGetter: (total) => {
        return formatCurrency(total);
      }
    }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), [filters, allowedWrite, printDocumentoLoading]);

  return (
    <>
      <div>
        <ImprimirMinutaGrillaFilters
          delegaciones={delegaciones}
          filters={filters}
          printLoading={printLoading}
          setImprimirMinutasGrilla={setImprimirMinutasGrilla}
          setImprimirMinutasGrillaLoading={setImprimirMinutasGrillaLoading}
          setDelegaciones={setDelegaciones}
          handleChangeFilters={handleChangeFilters}
          refetchGrilla={refetchGrilla}
          setRefetchGrilla={setRefetchGrilla} />

        <br />
        <DataGridGenerico
          columns={columns}
          rows={imprimirMinutasGrilla}
          toolbar={false}
          maxWidth={columns.reduce(
            (total, column) => total + (column.width || 0),
            0
          )}
          checkboxSelection={true}
          isRowSelectable={(param) => !disabledCheckbox(param.row)}
          onRowSelectionModelChange={(e) => handleSelectionModelChange(e)}
          rowSelectionModel={rowSelectionModel}
          loading={imprimirMinutasGrillaLoading} />

      </div>
      <Outlet />
    </>);

};